import { Fragment, useRef } from "react";
import ExpertVideos from "../component/ExpertVideos";
import TestimonialSwiper from "../component/TestimonialSwiper";
import ImageSwiper from "../component/ImageSwiper";
import FormDetail from "../component/FormDetail";
import JurySlider from "../component/JurySlider";
import DateSection from "../component/DateSection";
import HelpSection from "../component/HelpSection";
import BusinessSection from "../component/BusinessSection";
import MidRegister from "../component/MidRegister";
import Banner from "../component/Banner";
import BannerSwiper from "../component/BannerSwiper";
import img from "../assets/images/ram-sir.webp";

function QuoteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ariaHidden="true"
      className="e-font-icon-svg e-fas-quote-left"
      viewBox="0 0 512 512"
    >
      <path d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"></path>
    </svg>
  );
}

function QuoteRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
    <g>
      <g id="Layer_1">
        <path d="M48,256h80v64c0,35.3-28.7,64-64,64h-8c-13.3,0-24,10.7-24,24v48c0,13.3,10.7,24,24,24h8c88.4,0,160-71.6,160-160V80c0-26.5-21.5-48-48-48H48C21.5,32,0,53.5,0,80v128c0,26.5,21.5,48,48,48ZM336,256h80v64c0,35.3-28.7,64-64,64h-8c-13.3,0-24,10.7-24,24v48c0,13.3,10.7,24,24,24h8c88.4,0,160-71.6,160-160V80c0-26.5-21.5-48-48-48h-128c-26.5,0-48,21.5-48,48v128c0,26.5,21.5,48,48,48Z"/>
      </g>
    </g>
  </svg>
  );
}

const TestimonialsSection = () => {
  return (
    <section className="TestimonialsSection">
      <div className="container container-space">
        <div className="grid-2">
          <div>
            <img src={img} style={{ maxWidth: "300px" }} />
          </div>
          <div>
            
            <blockquote className="blockqoutecontent">
              <QuoteIcon />
              Charak Pharma pioneer in Ayurveda since 1947, 77 years has witnessed
              the dynamics of business in India. In a male dominating
              entrepreneur era we want to be the wave of change & empower women
              to be financially independent. With this thought it is a pleasure
              to bring to you all, the third edition of{" "}
              <b>moha: Stand on your feet</b> where we motivate each woman to
              see dreams & help realize them.
              <QuoteRight />
              <br />
              <br />
              <cite>
                <h3>Dr. Ram H. Shroff</h3>
                <p>Director, Charak Pharma</p>
              </cite>
            </blockquote>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default function Home2Page() {
  const myRef = useRef(null);
  const JurySelect = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();
  const JurySelectScroll = () => JurySelect.current.scrollIntoView();

  return (
    <Fragment>
      <h1>Page 2</h1>
      <BannerSwiper executeScroll={executeScroll} />
      {/* <PromoVideoSection /> */}
      <TestimonialsSection />
      <Banner executeScroll={executeScroll} />
      <MidRegister executeScroll={executeScroll} />
      {/* <VideoSection /> */}
      <BusinessSection executeScroll={executeScroll} />
      <HelpSection JurySelectScroll={JurySelectScroll} />
      <DateSection executeScroll={executeScroll} />
      <JurySlider JurySelect={JurySelect} />
      {/* <Participate /> */}
      <FormDetail myRef={myRef} />
      <ImageSwiper />
      <TestimonialSwiper />
      <ExpertVideos />
    </Fragment>
  )
}